/**
 * The signed-in admin, re-read when it changes.
 *
 * `authApi.getUser()` reads localStorage, so a component that calls it once at
 * render keeps whatever was there at mount — which is why editing a name on the
 * You page left the old one in the sidebar. Subscribing to the write makes the
 * chrome follow the edit without a reload or a context provider.
 *
 * `storage` covers the OTHER tab: a logout or a profile save in one console tab
 * should not leave a second tab showing a stale identity.
 */
import { useEffect, useState } from 'react';
import { authApi, type AdminUserInfo } from '../api/auth';

export function useAdminUser(): AdminUserInfo | null {
  const [user, setUser] = useState<AdminUserInfo | null>(() => authApi.getUser());

  useEffect(() => {
    const sync = () => setUser(authApi.getUser());
    window.addEventListener('admin-user-updated', sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener('admin-user-updated', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return user;
}
